import { render, staticRenderFns } from "./AvisoExistencias.vue?vue&type=template&id=71a963ea"
import script from "./AvisoExistencias.vue?vue&type=script&lang=js"
export * from "./AvisoExistencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports